module.exports = __webpack_public_path__ + "static/sustained-focus-e489d60a5754aea844704ce1f2f7cd94.webp";